export default function EnterpriseBanner() {
  return (
    <div className="block flex mt-6 mb-6 mx-auto container">
      <div className="p-10 md:py-14 md:px-28 bg-doctio-green border border-gray-200 w-full flex flex-col md:flex-row rounded-3xl shadow">
        <div>
          <h5 className="mb-2 text-7xl font-bold tracking-tight text-white">
            Enterprise
          </h5>
          <p className="text-white">
            Lavet til klinikker og sygehuse der ønsker flere licenser. Kontakt
            os for nærmere aftale.
          </p>
        </div>
        <div className="flex items-center md:ml-auto justify-center">
          <a
            href="/kontakt"
            className="py-2.5 px-10 me-2 mb-2 font-bold text-doctio-green focus:outline-none bg-white rounded-full border border-gray-200  "
          >
            Kontakt os
          </a>
        </div>
      </div>
    </div>
  );
}
